import { Options } from 'highcharts';

import { useUserLocale } from '@/i18n/hooks';
import { Unit } from '@/types/Unit';

import { getUnitNumberFormat } from '../utils/getUnitNumberFormat';
import { ColumnChartData } from './types/ColumnChartData';

export const useColumnChartOptions = (
  data: ColumnChartData[],
  min: number | undefined,
  max: number | undefined,
  unit: Unit,
  showLegend?: boolean,
): Options => {
  const locale = useUserLocale();

  return {
    chart: {
      type: 'column',
      height: 500,
      numberFormatter(value) {
        return getUnitNumberFormat(value, unit, locale);
      },
    },
    plotOptions: {
      column: {
        maxPointWidth: 36,
        tooltip: {
          headerFormat: undefined,
        },
      },
    },
    yAxis: {
      min,
      max,
      title: undefined,
      labels: {
        style: {
          color: 'var(--p-color-text-primary)',
          fontSize: '14px',
          fontWeight: '400',
        },
      },
      lineColor: 'var(--p-color-stroke-subtle-0-grey)',
      tickColor: 'var(--p-color-stroke-subtle-0-grey)',
    },
    xAxis: {
      type: 'category',
      labels: {
        rotation: -45,
        style: {
          fontSize: '14px',
          color: 'var(--p-color-text-primary)',
          fontWeight: '400',
          lineHeight: '24px',
        },
      },
      lineColor: 'var(--p-color-stroke-subtle-0-grey)',
      tickColor: 'var(--p-color-stroke-subtle-0-grey)',
    },
    series: data.map((series) => ({
      type: 'column',
      name: series.title,
      data: series.dataPoints,
    })),
    colors: [
      'var(--p-color-categorical-1)',
      'var(--p-color-categorical-2)',
      'var(--p-color-categorical-3)',
      'var(--p-color-categorical-4)',
      'var(--p-color-categorical-5)',
      'var(--p-color-categorical-6)',
      'var(--p-color-categorical-7)',
      'var(--p-color-categorical-8)',
      'var(--p-color-categorical-9)',
      'var(--p-color-categorical-10)',
      'var(--p-color-categorical-11)',
      'var(--p-color-categorical-12)',
    ],
    title: undefined,
    legend: {
      enabled: showLegend,
      itemStyle: {
        fontSize: '14px',
        color: 'var(--p-color-text-primary)',
        fontWeight: '400',
      },
      itemDistance: 24,
      itemMarginBottom: 8,
    },
    credits: {
      enabled: false,
    },
  };
};
